import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/pages/Home'
import Login from '@/pages/Login'

import Register from '@/pages/Register'

import NewPeople from '@/pages/panel/floorarea/NewPeople'

// Start New People Seat
import NewPeopleChair from '@/pages/panel/floorarea/NewPeopleChair'
import SeatInfo from '@/pages/panel/floorarea/SeatInfo'
// End New People Seat

import ForgotPassword from '@/pages/Forgot_password'
import ForgotPasswordVerify from '@/pages/Forgot_password_verify'

// import Dashboard from '@/pages/Dashboard'

import NoAbsent from '@/pages/NoAbsent'
import Panel from '@/pages/panel/Home'
import Logout from '@/pages/panel/Logout'

import Frontdesk from '@/pages/panel/frontdesk/Home'
import FrontdeskEdc from '@/pages/panel/frontdesk/Edc'
import FrontdeskDashboard from '@/pages/panel/frontdesk/Dashboard'
import FrontdeskGiving from '@/pages/panel/frontdesk/Giving'
import FrontdeskGivingUpdate from '@/pages/panel/frontdesk/Giving_update'
import FrontdeskEvent from '@/pages/panel/frontdesk/Event'
import FrontdeskEventUpdate from '@/pages/panel/frontdesk/Event_update'
import FrontdeskEventComplimentary from '@/pages/panel/frontdesk/EventComplimentary'
import FrontdeskCloseCounter from '@/pages/panel/frontdesk/Close_counter'

import FrontdeskMyTransactions from '@/pages/panel/frontdesk/MyTransactions'
import FrontdeskTransactions from '@/pages/panel/frontdesk/Transactions'
import FrontdeskReportCounter from '@/pages/panel/frontdesk/report/Counter'
import FrontdeskReport from '@/pages/panel/frontdesk/report/Leader'
import FrontdeskReportCampusCoordinator from '@/pages/panel/frontdesk/report/CampusCoordinator'
import FrontdeskReportHeadDivision from '@/pages/panel/frontdesk/report/HeadDivision'
import FrontdeskReportEventCounter from '@/pages/panel/frontdesk/report_event/Counter'
import FrontdeskReportEvent from '@/pages/panel/frontdesk/report_event/Leader'
import FrontdeskReportEventCampusCoordinator from '@/pages/panel/frontdesk/report_event/CampusCoordinator'
import FrontdeskReportEventHeadDivision from '@/pages/panel/frontdesk/report_event/HeadDivision'

import FrontdeskEventService from '@/pages/panel/frontdesk/EventService'
import FrontdeskEventServiceCounter from '@/pages/panel/frontdesk/EventServiceCounter'

import FrontdeskSummaryService from '@/pages/panel/frontdesk/summary/Service'

import Edc from '@/pages/panel/edc/Home'
import EdcInsert from '@/pages/panel/edc/Insert'
import EdcUpdate from '@/pages/panel/edc/Update'

import Role from '@/pages/panel/role/Home'
import RoleInsert from '@/pages/panel/role/Insert'
import RoleUpdate from '@/pages/panel/role/Update'
import RoleMenu from '@/pages/panel/role/Menu'

import Menu from '@/pages/panel/menu/Home'
import MenuInsert from '@/pages/panel/menu/Insert'
import MenuUpdate from '@/pages/panel/menu/Update'

import EventList from '@/pages/panel/event/Home'
import EventInsert from '@/pages/panel/event/Insert'
import EventUpdate from '@/pages/panel/event/Update'

// Division
import DivisionList from '@/pages/panel/division/Home'
import DivisionInsert from '@/pages/panel/division/Insert'
import DivisionUpdate from '@/pages/panel/division/Update'
import DivisionMenu from '@/pages/panel/division/Menu'

import CampusCoordinatorList from '@/pages/panel/division/campus_coordinator/Home'
import CampusCoordinatorInsert from '@/pages/panel/division/campus_coordinator/Insert'
import CampusCoordinatorUpdate from '@/pages/panel/division/campus_coordinator/Update'
import CampusCoordinatorMenu from '@/pages/panel/division/campus_coordinator/Menu'

import TeamList from '@/pages/panel/division/team/Home'
import TeamInsert from '@/pages/panel/division/team/Insert'
import TeamUpdate from '@/pages/panel/division/team/Update'
import TeamLeaderMenu from '@/pages/panel/division/team/MenuTeamLeader'
import TeamMenu from '@/pages/panel/division/team/MenuTeamMember'
// End Division

// Team Member Head Division
import TeamMemberHeadDivision from '@/pages/panel/team_member/hd/Home'
import TeamMemberHeadDivisionTeam from '@/pages/panel/team_member/hd/Team'
// End Team Member Head Division
// Team Member Campus Coordinator
import TeamMemberCampusCoordinator from '@/pages/panel/team_member/cc/Home'
// End Team Member Campus Coordinator
// Team Member Team Leader
import TeamMemberTeamLeader from '@/pages/panel/team_member/tl/Home'
// End Team Member Team Leader
// Team Member Team Member
import TeamMemberTeamMember from '@/pages/panel/team_member/tm/Home'
// End Team Member Team Member

// Task Service
import Task from '@/pages/panel/task/Home'
import TaskService from '@/pages/panel/task/Service'
import TaskFinish from '@/pages/panel/task/Finish'
import TaskAttendance from '@/pages/panel/task/Attendance'
// End Task Service

import Trainee from '@/pages/panel/trainee/Home'

import Giving from '@/pages/panel/giving/Home'

import Member from '@/pages/panel/member/Home'
import MemberRole from '@/pages/panel/member/Role'

import Profile from '@/pages/panel/profile/Home'

import Attendance from '@/pages/panel/teamleader/Attendance'

import NewMember from '@/pages/NewMember'
import NewMemberList from '@/pages/panel/new_member/Home'

import OverMember from '@/pages/OverMember'

import DeviceCheck from '@/pages/panel/DeviceCheck'
import RegisterDevice from '@/pages/panel/RegisterDevice'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: '',
      component: Home,
      children: [
        {
          path: 'register_device',
          name: 'Register Device',
          component: RegisterDevice
        },
        {
          path: 'device_check',
          name: 'Device Check',
          component: DeviceCheck
        },
        {
          path: 'overmember',
          name: 'Over Member',
          component: OverMember
        },
        {
          path: '/',
          name: 'Login',
          component: Login
        },
        {
          path: '/new_member',
          name: 'New Member',
          component: NewMember
        },
        {
          path: '/new_people',
          name: 'New People',
          component: NewPeople
        },
        {
          path: '/no_absent',
          name: 'No Absent',
          component: NoAbsent
        },
        {
          path: '/new_people_chair',
          name: 'New People Chair',
          component: NewPeopleChair
        },
        {
          path: '/forgot_password',
          name: 'Forgot Password',
          component: ForgotPassword
        },
        {
          path: '/forgot_password/verify/:code',
          name: 'Forgot Password Verify',
          component: ForgotPasswordVerify
        },
        {
          path: '/register',
          name: 'Register',
          component: Register
        },
        {
          path: 'panel/',
          name: 'Panel',
          component: Panel,
          children: [
            {
              path: 'lost_found',
              name: 'Lost and Found',
              component: () => import('@/pages/panel/lost_found/Home')
            },
            {
              path: 'lost_found/insert',
              name: 'Lost and Found Insert',
              component: () => import('@/pages/panel/lost_found/Insert')
            },
            {
              path: 'lost_found/update/:id',
              name: 'Lost and Found Update',
              component: () => import('@/pages/panel/lost_found/Update')
            },
            {
              path: 'lost_found/hand_over/:id',
              name: 'Lost and Found Hand Over',
              component: () => import('@/pages/panel/lost_found/Hand_over')
            },
            {
              path: 'lost_found/searching_item',
              name: 'Lost and Found Searching Item',
              component: () => import('@/pages/panel/lost_found/searching_item/Home')
            },
            {
              path: 'lost_found/searching_item/insert',
              name: 'Lost and Found Searching Item Insert',
              component: () => import('@/pages/panel/lost_found/searching_item/Insert')
            },
            {
              path: 'lost_found/searching_item/update/:id',
              name: 'Lost and Found Searching Item Update',
              component: () => import('@/pages/panel/lost_found/searching_item/Update')
            },
            {
              path: 'floorarea/seat_management',
              name: '',
              component: NewPeopleChair
            },
            {
              path: 'floorarea/seat_info',
              name: '',
              component: SeatInfo
            },
            {
              path: 'frontdesk/',
              name: '',
              component: Frontdesk,
              children: [
                {
                  path: '/',
                  name: 'Frontdesk Edc',
                  component: FrontdeskEdc
                },
                {
                  path: 'dashboard/',
                  name: 'Frontdesk Dashboard',
                  component: FrontdeskDashboard
                },
                {
                  path: 'giving/',
                  name: 'Frontdesk Giving',
                  component: FrontdeskGiving
                },
                {
                  path: 'giving_update/:id',
                  name: 'Frontdesk Giving Update',
                  component: FrontdeskGivingUpdate
                },
                {
                  path: 'event/',
                  name: 'Event List',
                  component: FrontdeskEvent
                },
                {
                  path: 'event_update/:id',
                  name: 'Event List Update',
                  component: FrontdeskEventUpdate
                },
                {
                  path: 'event_complimentary/',
                  name: 'Event Complimentary List',
                  component: FrontdeskEventComplimentary
                },
                {
                  path: 'my_transactions/',
                  name: 'My Transactions',
                  component: FrontdeskMyTransactions
                },
                {
                  path: 'transactions/',
                  name: 'Transactions',
                  component: FrontdeskTransactions
                },
                {
                  path: 'report_counter',
                  name: 'Report Counter',
                  component: FrontdeskReportCounter
                },
                {
                  path: 'report/',
                  name: 'Report',
                  component: FrontdeskReport
                },
                {
                  path: 'report_cc/',
                  name: 'Report Campus Coordinator',
                  component: FrontdeskReportCampusCoordinator
                },
                {
                  path: 'report_hd/',
                  name: 'Report Head Division',
                  component: FrontdeskReportHeadDivision
                },
                {
                  path: 'report_event_counter/',
                  name: 'Report Event Counter',
                  component: FrontdeskReportEventCounter
                },
                {
                  path: 'report_event/',
                  name: 'Report Event',
                  component: FrontdeskReportEvent
                },
                {
                  path: 'report_event_cc/',
                  name: 'Report Event Campus Coordinator',
                  component: FrontdeskReportEventCampusCoordinator
                },
                {
                  path: 'report_event_hd/',
                  name: 'Report Event Head Division',
                  component: FrontdeskReportEventHeadDivision
                },
                {
                  path: 'event_service/',
                  name: 'Event Service',
                  component: FrontdeskEventService
                },
                {
                  path: 'event_service_counter/',
                  name: 'Event Service Counter',
                  component: FrontdeskEventServiceCounter
                },
                {
                  path: 'close_counter',
                  name: 'Close Counter',
                  component: FrontdeskCloseCounter
                },
                {
                  path: 'summary/service',
                  name: 'Summary Service',
                  component: FrontdeskSummaryService
                }
              ]
            },
            // Division
            {
              path: 'division/',
              name: 'Division',
              component: DivisionList
            },
            {
              path: 'division/insert/',
              name: 'Division Insert',
              component: DivisionInsert
            },
            {
              path: 'division/update/:id',
              name: 'Division Update',
              component: DivisionUpdate
            },
            {
              path: 'division/menu/:id',
              name: 'Division Menu',
              component: DivisionMenu
            },
            {
              path: 'division/campus_coordinator/:parent_id',
              name: 'Campus Coordinator',
              component: CampusCoordinatorList
            },
            {
              path: 'division/campus_coordinator/insert/:parent_id',
              name: 'Campus Coordinator Insert',
              component: CampusCoordinatorInsert
            },
            {
              path: 'division/campus_coordinator/update/:parent_id/:id',
              name: 'Campus Coordinator Update',
              component: CampusCoordinatorUpdate
            },
            {
              path: 'division/campus_coordinator/menu/:parent_id/:id',
              name: 'Campus Coordinator Menu',
              component: CampusCoordinatorMenu
            },
            {
              path: 'division/team/:parent_id',
              name: 'Team',
              component: TeamList
            },
            {
              path: 'division/team/insert/:parent_id',
              name: 'Team Insert',
              component: TeamInsert
            },
            {
              path: 'division/team/update/:parent_id/:id',
              name: 'Team Update',
              component: TeamUpdate
            },
            {
              path: 'division/team/leader_menu/:parent_id/:id',
              name: 'Team Leader Menu',
              component: TeamLeaderMenu
            },
            {
              path: 'division/team/menu/:parent_id/:id',
              name: 'Team Menu',
              component: TeamMenu
            },
            // End Division
            // Team Member Head Division
            {
              path: 'team_member/hd/',
              name: 'Team Member Head Division',
              component: TeamMemberHeadDivision
            },
            {
              path: 'team_member/hd/team/:id',
              name: 'Team Member Head Division Team',
              component: TeamMemberHeadDivisionTeam
            },
            // End Team Member Head Division
            // Team Member Campus Coordinator
            {
              path: 'team_member/cc/',
              name: 'Team Member Campus Coordinator',
              component: TeamMemberCampusCoordinator
            },
            // End Team Member Campus Coordinator
            // Team Member Team Leader
            {
              path: 'team_member/tl/',
              name: 'Team Member Team Leader',
              component: TeamMemberTeamLeader
            },
            // End Team Member Team Leader
            // Team Member Team Member
            {
              path: 'team_member/tm/',
              name: 'Team Member Team Member',
              component: TeamMemberTeamMember
            },
            // End Team Member Team Member
            // Task Service
            {
              path: 'task',
              name: 'Task',
              component: Task
            },
            {
              path: 'task_service',
              name: 'Task Service',
              component: TaskService
            },
            {
              path: 'task_finish',
              name: 'Task Finish',
              component: TaskFinish
            },
            {
              path: 'task/attendance',
              name: 'Task Attendance',
              component: TaskAttendance
            },
            // End Task Service
            {
              path: 'new_member/',
              name: 'New Member List',
              component: NewMemberList
            },
            {
              path: 'profile/',
              name: 'Profile',
              component: Profile
            },
            {
              path: 'giving/',
              name: 'Giving',
              component: Giving
            },
            {
              path: 'edc/',
              name: 'EDC',
              component: Edc
            },
            {
              path: 'edc/insert/',
              name: 'EDC Insert',
              component: EdcInsert
            },
            {
              path: 'edc/update/:id',
              name: 'EDC Update',
              component: EdcUpdate
            },
            {
              path: 'teamleader/attendance',
              name: 'Attendance',
              component: Attendance
            },
            {
              path: 'member',
              name: 'Member',
              component: Member
            },
            {
              path: 'member/role',
              name: 'Member Role',
              component: MemberRole
            },
            {
              path: 'role/',
              name: 'Role',
              component: Role
            },
            {
              path: 'role/insert/',
              name: 'Role Insert',
              component: RoleInsert
            },
            {
              path: 'role/update/:id',
              name: 'Role Update',
              component: RoleUpdate
            },
            {
              path: 'role/menu/:id',
              name: 'Role Menu',
              component: RoleMenu
            },
            {
              path: 'menu/',
              name: 'Menu',
              component: Menu
            },
            {
              path: 'menu/insert/',
              name: 'Menu Insert',
              component: MenuInsert
            },
            {
              path: 'menu/update/:id',
              name: 'Menu Update',
              component: MenuUpdate
            },
            {
              path: 'trainee/',
              name: 'Trainee',
              component: Trainee
            },
            {
              path: 'event/',
              name: 'Event',
              component: EventList
            },
            {
              path: 'event/insert/',
              name: 'Event Insert',
              component: EventInsert
            },
            {
              path: 'event/update/:id',
              name: 'Event Update',
              component: EventUpdate
            },
            {
              path: 'logout',
              name: 'Logout',
              component: Logout
            }
          ]
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js